import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { CategoriesService } from '@service/categories.service';
import { StateService } from '@service/state.service';
import { DialogType } from '@type/dialog-type';

@Component({
  selector: 'app-introduction-dialog',
  templateUrl: './introduction-dialog.component.html',
  styleUrls: ['./introduction-dialog.component.scss'],
})
export class IntroductionDialogComponent {
  public environment = environment;

  public static cssClass: DialogType = 'darkgray-fullscreen-dialog';

  constructor(
    public dialogRef: MatDialogRef<IntroductionDialogComponent>,
    public CategoriesService: CategoriesService,
    public StateService: StateService,
  ) {}

  public goto(name: string, data = {}) {
    this.StateService.goto(name, data);

    this.close();
  }

  public close() {
    this.dialogRef.close();
  }
}
